import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CustomIconButton, Tooltip } from "../../../components";
import { DeleteForever } from "../../../icons";

// todo: disable delete on permission

function SuppressionListActions({ onDelete, suppressed, canDelete }) {
  const { t } = useTranslation();

  const _onDelete = useCallback(() => onDelete(suppressed), [
    onDelete,
    suppressed,
  ]);

  return (
    <>
      <Tooltip title={t("Delete suppression number")}>
        <CustomIconButton
          size="small"
          color="error"
          onClick={_onDelete}
          disabled={!canDelete}
        >
          <DeleteForever fontSize="small" />
        </CustomIconButton>
      </Tooltip>
    </>
  );
}

export default memo(SuppressionListActions);
